module.exports = __webpack_public_path__ + "img/about-bg.a0cd5d13.svg";